/**
 * @generated SignedSource<<c7e0f26bb73dc1c1271801079aa482ab>>
 * @relayHash 0338e1ad9a17b74a51ceb84d72bc7c61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e3efc04c3bd70f0dd085cb5ca373f071edfe850c1e5c8170567f9dc326950578

import type { ConcreteRequest } from 'relay-runtime';
export type ContentRendererMode = "EDITOR" | "PDF" | "RENDERER" | "%future added value";
export type LegacyMacroRendererQueryBodyQuery$variables = {
  adf: string;
  containedRender?: boolean | null | undefined;
  contentId?: string | null | undefined;
  mode?: ContentRendererMode | null | undefined;
};
export type LegacyMacroRendererQueryBodyQuery$data = {
  readonly macroBodyRenderer: {
    readonly mediaToken: {
      readonly token: string | null | undefined;
    } | null | undefined;
    readonly representation: string | null | undefined;
    readonly value: string | null | undefined;
    readonly webResourceDependencies: {
      readonly contexts: ReadonlyArray<string | null | undefined>;
      readonly keys: ReadonlyArray<string | null | undefined>;
      readonly tags: {
        readonly css: string | null | undefined;
        readonly js: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type LegacyMacroRendererQueryBodyQuery = {
  response: LegacyMacroRendererQueryBodyQuery$data;
  variables: LegacyMacroRendererQueryBodyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "adf"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "containedRender"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": "RENDERER",
    "kind": "LocalArgument",
    "name": "mode"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "adf",
        "variableName": "adf"
      },
      {
        "kind": "Variable",
        "name": "containedRender",
        "variableName": "containedRender"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "mode",
        "variableName": "mode"
      }
    ],
    "concreteType": "MacroBody",
    "kind": "LinkedField",
    "name": "macroBodyRenderer",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "value"
      },
      {
        "kind": "ScalarField",
        "name": "representation"
      },
      {
        "concreteType": "EmbeddedMediaToken",
        "kind": "LinkedField",
        "name": "mediaToken",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "token"
          }
        ]
      },
      {
        "concreteType": "WebResourceDependencies",
        "kind": "LinkedField",
        "name": "webResourceDependencies",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "contexts"
          },
          {
            "kind": "ScalarField",
            "name": "keys"
          },
          {
            "concreteType": "WebResourceTags",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "js"
              },
              {
                "kind": "ScalarField",
                "name": "css"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LegacyMacroRendererQueryBodyQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LegacyMacroRendererQueryBodyQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0338e1ad9a17b74a51ceb84d72bc7c61",
    "id": "e3efc04c3bd70f0dd085cb5ca373f071edfe850c1e5c8170567f9dc326950578",
    "metadata": {},
    "name": "LegacyMacroRendererQueryBodyQuery",
    "operationKind": "query",
    "text": "query LegacyMacroRendererQueryBodyQuery($adf:String!,$containedRender:Boolean=false,$contentId:ID,$mode:ContentRendererMode=RENDERER)@allowHigherTimeout{macroBodyRenderer(adf:$adf,containedRender:$containedRender,contentId:$contentId,mode:$mode){value,representation,mediaToken{token},webResourceDependencies{contexts,keys,tags{js,css}}}}"
  }
};
})();

(node as any).hash = "dd7355924ba42269bd10c6f111b4c390";

export default node;
